import { Stack, Container, Typography } from '@mui/material';
import { useBoolean } from 'src/hooks/use-boolean';
import { useState, useEffect } from 'react';
import { toastError } from 'src/utils/format-error';
import axios, { endpoints } from 'src/utils/axios';
import { ProductType, ProductPriceLog } from 'src/type/product';
import LoadingContainer from 'src/components/ui-kit/loading-container';
import EmptyContent from 'src/components/empty-content';
import { Pagination } from 'src/type/utils';
import GoldPriceInputCard from '../gold-price-input-card';

export default function GoldPriceView() {
  const loading = useBoolean(true);
  const [products, setProducts] = useState<ProductType[]>([]);
  const reload = useBoolean(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get<Pagination<ProductType>>(endpoints.product.get);
        const productWithPriceLogs = await Promise.all(
          data.results.map(async (product) => {
            const { data: logs } = await axios.get<Pagination<ProductPriceLog>>(
              `${endpoints.product.priceLog}?productId=${product.id}&limit=30&orderBy=createdAt:desc`
            );
            return { ...product, productPriceLog: logs.results };
          })
        );
        setProducts(productWithPriceLogs);
      } catch (error) {
        toastError(error);
      } finally {
        loading.onFalse();
      }
    })();
  }, [reload.value]);

  return (
    <Container>
      <Stack spacing={3}>
        <Typography variant="h4" gutterBottom>
          อัพเดทราคาทองของระบบ
        </Typography>

        <LoadingContainer loading={loading.value} fitContent sx={{ height: '50vh' }}>
          <Stack spacing={2}>
            {products.map((product) => {
              if (!product.isEnable) return null;
              return (
                <GoldPriceInputCard
                  key={product.id}
                  product={product}
                  forceReload={reload.onToggle}
                />
              );
            })}

            {!products.length && <EmptyContent title="ไม่พบข้อมูล" sx={{ mt: 4 }} />}
          </Stack>
        </LoadingContainer>
      </Stack>
    </Container>
  );
}
